import { Box } from '@mui/material';
import { forwardRef } from 'react';

export const MobileSignalIcon = forwardRef(
  (
    {
      height = '125px',
      width = '125px',
      signalStrength = 'low',
      colorScheme = {
        low: 'green',
        medium: 'orange',
        high: 'red',
      },
      numberOfBars = 6,
    } = {},
    ref
  ) => {
    const generateSignals = () => {
      let signalBarJsx = [];

      for (let i = 0; i < numberOfBars; i++) {
        let percentage = (100 / numberOfBars) * i;
        if (i === 0) {
          percentage += 12;
        }
        let bgColor = 'white';

        if (signalStrength === 'none' && percentage <= 12) {
          bgColor = 'white';
        }
        if (signalStrength === 'low' && percentage <= 33.3) {
          bgColor = colorScheme?.low;
        }

        if (signalStrength === 'medium' && percentage <= 66.6) {
          bgColor = colorScheme?.medium;
        }

        if (signalStrength === 'high' && percentage < 100) {
          bgColor = colorScheme?.high;
        }

        let barJsx = (
          <Box
            sx={{
              border: '1px solid black',
              height: `${percentage}%`,
              width: '35px',
              backgroundColor: `${bgColor}`,
            }}
          ></Box>
        );

        signalBarJsx.push(barJsx);
      }

      return signalBarJsx;
    };

    return (
      <>
        <Box
          sx={{
            display: 'flex',
            width: `${width}`,
            height: `${height}`,
            boxSizing: 'border-box',
            alignItems: 'baseline',
          }}
        >
          {generateSignals()}
        </Box>
      </>
    );
  }
);
